import validator from 'validator';
import emailAddresses from 'email-addresses';

export default function (email: string): boolean {
  return (
    validator.isEmail(email, { allow_utf8_local_part: false }) &&
    !!emailAddresses.parseOneAddress(email)
  );
}